import type { ConsentCategory, ConsentCookieNameMap } from './constants'

export function parseConsentCookies(
  cookie: string | null | undefined,
  { acknowledged: ackCookie, ...categoryCookies }: ConsentCookieNameMap,
) {
  const allowed = new Set<ConsentCategory>()
  let acknowledged = false

  if (cookie) {
    const parts = cookie.split(';')
    for (const part of parts) {
      const [key = '', value = ''] = part.split('=').map((s) => s.trim())
      if (value !== 'true') continue

      if (key === ackCookie) {
        acknowledged = true
        continue
      }

      for (const [category, cookieNames] of Object.entries(categoryCookies)) {
        if (cookieNames.includes(key)) {
          allowed.add(category as ConsentCategory)
          acknowledged = true
          continue
        }
      }
    }
  }

  return { allowed, acknowledged }
}
